"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_PREFIX = 'ff';
exports.KEY_DELIMETER = '_';
exports.getKey = function (key) { return exports.KEY_PREFIX + exports.KEY_DELIMETER + key; };
exports.safeParseJSON = function (value) {
    try {
        return JSON.parse(value);
    }
    catch (err) { }
    return value;
};
var hasPrefix = function (key) { return key.startsWith(exports.KEY_PREFIX + exports.KEY_DELIMETER); };
var removePrefix = function (key) { return key.slice(exports.KEY_PREFIX.length + 1); };
exports.mapFromStoredValuesWithPrefix = function (stored, getter) {
    return Object.entries(stored).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        if (hasPrefix(key)) {
            var flagName = removePrefix(key);
            acc[flagName] = getter(flagName);
        }
        return acc;
    }, {});
};
//# sourceMappingURL=utils.js.map